import Image from 'next/legacy/image'
import { FC } from 'react'
import { GiftBoxIcon, GiftExchangeIcon, GiftReceiptIcon } from './gift-icons'

const features = [
  { Icon: GiftBoxIcon, label: 'Luxe gift box/wrapping with card included' },
  { Icon: GiftReceiptIcon, label: 'Gift receipt provided' },
  { Icon: GiftExchangeIcon, label: 'Exchange available in-store or online' },
]

/**
 * Gifting promo block shown on the PDP, beneath the product info accordions.
 * Horizontal layout: background image on the left, copy on the right.
 */
const GiftingBlock: FC = () => {
  return (
    <div className="mt-5 flex items-stretch overflow-hidden rounded-[4px] bg-brand-polar-white">
      <div className="relative w-1/2 shrink-0 lg:w-[35%]">
        <Image
          src="/gifting_image.jpg"
          alt=""
          layout="fill"
          objectFit="cover"
          sizes="(min-width: 1024px) 146px, 50vw"
          unoptimized
        />
        <div className="absolute inset-0 bg-black/[0.15]" />
      </div>

      <div className="flex flex-1 flex-col gap-2 p-4">
        <div className="flex flex-col gap-1 text-13 leading-5 text-text-subdued">
          <p className="font-bold">Gifting made easy</p>
          <p>A special milestone or just because, we have got you covered.</p>
        </div>

        <ul className="flex flex-col gap-1 text-text-disabled">
          {features.map(({ Icon, label }) => (
            <li
              key={label}
              className="flex items-center gap-2 text-10 leading-4"
            >
              <Icon className="h-[18px] w-[18px] shrink-0" />
              <span>{label}</span>
            </li>
          ))}
        </ul>

        <p className="text-13 leading-5 text-text-subdued">
          Add gift wrapping in cart for $6.95
        </p>
      </div>
    </div>
  )
}

export default GiftingBlock
